export default __webpack_public_path__ + "static/media/check-circle.a3267c81.svg";